// import React, { useEffect, useState } from "react";
// import styles from '../styles/home.module.css';
// import PropTypes from "prop-types";
// import { ToastContainer, toast } from 'react-toastify';
// import axios from "axios";
// import { Spinner } from "react-activity";

// const HomePage = ({ ip }) => {
//     const [connectionType, setConnectionType] = useState("unknown");
//     const [userAgent, setUserAgent] = useState("");
//     const [hashedMsisdn, setHashedMsisdn] = useState("");
//     const [isWifi, setIsWifi] = useState(false);
//     const [clickId, setClickId] = useState("");
//     const [pub, setPub] = useState("");
//     const [refId, setRefId] = useState("");
//     const [userToken, setUserToken] = useState("");
//     const [loading, setLoading] = useState(false);
//     const [hashedNo, setHashedNo] = useState('');

//     // ✅ Detect WiFi
//     const detectWiFi = async () => {
//         if (navigator.connection) {
//             const { type, effectiveType, downlink } = navigator.connection;
//             if (type === "wifi" || effectiveType === "wifi" || downlink > 10) {
//                 return true;
//             }
//         }
//         return !(await checkSafaricomNetwork());
//     };

//     // ✅ Check if user is on Safaricom Mobile Data
//     const checkSafaricomNetwork = async () => {
//         try {
//             const response = await fetch("https://identity.safaricom.com");
//             return response.ok;
//         } catch {
//             return false;
//         }
//     };

//     useEffect(() => {
//         const urlParams = new URLSearchParams(window.location.search);
//         setPub(urlParams.get('pub') || "");
//         setClickId(urlParams.get('click_id') || "");
//         setHashedNo(urlParams.get('hashed_id') || "");
//         setRefId(urlParams.get('ref_id') || "");
//         setUserAgent(navigator.userAgent);

//         const checkNetworkAndFetchData = async () => {
//             if (!hashedNo) {
//                 fetchToken();
//             } else {
//                 setHashedMsisdn(hashedNo);
//             }
//         };

//         checkNetworkAndFetchData();
//     }, [hashedNo]);

//     useEffect(()=>{
//         if (hashedMsisdn && refId) {
//             sendConsentRequest();
//         }
//     }, [hashedMsisdn, hashedNo])

//     // ✅ Fetch authentication token
//     const fetchToken = async () => {
//         try {
//             const response = await axios.get("https://he-api.subscrption.gamepoa.com/appToken/getHashedToken");
//             if (response.status === 200) {
//                 const token = response.data.access_token;
//                 setUserToken(token);
//                 console.log("User token:", token);

//                 // Wait for token update before fetching MSISDN
//                 await fetchMsisdn(token);
//             }
//         } catch (error) {
//             console.error("Error fetching token:", error);
//             toast.error("Failed to fetch authentication token.");
//         }
//     };

//     // // ✅ Fetch user's masked MSISDN
//     // const fetchMsisdn = async (token) => {
//     //     try {
//     //         const { data } = await axios.get("https://identity.safaricom.com/partner/api/v2/fetchMaskedMsisdn", {
//     //             headers: {
//     //                 'Content-Type': 'application/json',
//     //                 'Authorization': `Bearer ${token}`,  // ✅ Use fresh token
//     //                 'X-App': 'he-partner',
//     //                 'X-Source-System': 'he-partner',
//     //                 'X-messageid': '1234'
//     //             },
//     //         });

//     //         if (data?.ServiceResponse?.ResponseHeader?.ResponseCode === "204") {
//     //             toast.error("Please switch to Safaricom Mobile Data!");
//     //         } else if (data?.ServiceResponse?.ResponseHeader?.ResponseCode === "200") {
//     //             setHashedMsisdn(data.ServiceResponse.ResponseBody?.Response?.Msisdn || "");
//     //         }
//     //     } catch (error) {
//     //         console.error("Please switch to Safaricom Mobile Data!", error);
//     //         toast.error("Please switch to Safaricom Mobile Data!");
//     //     }
//     // };

//     // ✅ Send subscription consent request
//     const sendConsentRequest = async () => 
        
//         setLoading(true);
    
//         try {
//             const response = await axios.post("https://api.mfilter.gamepoa.com/app/v1/subscribe", {
//                 msisdn: hashedMsisdn,
//                 sourceIp: ip,
//                 userAgent,
//                 redirectUrl: "https://play.gamepoa.com/",
//                 offerCode: refId,
//             });
    
//             if (response.status === 200) {
//                 console.log("Consent response:", response.data);
    
//                 // ✅ Directly access response properties
//                 const { cg_url, refId } = response.data;
    
//                 if (cg_url) {
//                     console.log("Redirecting to:", cg_url);
                    
//                     // ✅ Debugging: Log all values before calling tracking
//                     console.log("Tracking Parameters:", { clickId, pub, hashedMsisdn, refId });
    
//                     // ✅ Step 1: Call tracking API
//                     if (clickId && pub && hashedMsisdn && refId) {
//                         const proxyUrl = "https://api.allorigins.win/raw?url="; // Change proxy if needed
//                         const trackUrl = "https://bt.levalu.in/sr/ke/sf/SuperKids/index.php";
                    
//                         const requestData = {
//                             click_id: clickId,
//                             pub: pub,
//                             Msisdn: hashedMsisdn,
//                             ref_id: refId
//                         };
                    
//                         try {
//                             const trackResponse = await axios.post(proxyUrl + encodeURIComponent(trackUrl), requestData, {
//                                 headers: {
//                                     "Content-Type": "application/json",
//                                 }
//                             });
                    
//                             console.log("Tracking API Response:", trackResponse.data);
//                             toast.success(`Tracking Success! Status: ${trackResponse.status}`);
                    
//                         } catch (trackError) {
//                             console.error("Tracking API failed:", trackError);
//                             toast.error(`Tracking failed! Status: ${trackError.response?.status || "Unknown"}`);
//                         }
//                     } else {
//                         console.warn("Tracking skipped due to missing parameters.");
//                     }
                    
                    
                     
                    
    
//                     // ✅ Step 2: Redirect user
//                     window.location.href = cg_url;
    
//                 } else {
//                     toast.error("No redirect URL received from the server.");
//                 }
//             } else {
//                 toast.error("Error sending consent request.");
//             }
//         } catch (error) {
//             console.error("Error sending consent request:", error);
//             toast.error("Failed to send consent request.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const pageReload=()=>{
//         location.reload()
//     }
    
    
//     // ✅ Detect Safari browser
//     const isSafari = () => {
//         const ua = navigator.userAgent.toLowerCase();
//         return ua.includes("safari") && !ua.includes("chrome");
//     };

//     return (
//         <div className={styles.container}>
//             <div className={styles.containerInner}>
                
//                         {loading ? (
//                             <Spinner  />
//                         ) : (
//                             <p onClick={pageReload} style={{textDecoration:'underline', fontWeight:'bold', cursor:'pointer'}}> Please try again!</p>                         
//                         )}
                
//                 <ToastContainer />
//             </div>
//         </div>
//     );
// };

// HomePage.propTypes = {
//     ip: PropTypes.string.isRequired,
// };

// export default HomePage;

// // ✅ Get user's IP on the server side
// export async function getServerSideProps(context) {
//     const { req } = context;
//     const ip = req.headers["x-forwarded-for"]?.split(",")[0] || req.headers["x-real-ip"] || req.connection.remoteAddress;
//     return { props: { ip } };
// }